module.exports = __webpack_public_path__ + "img/rip-stop.64fc67ce.jpeg";